import Vue from "vue"

const SlaughterProgrammingEventBus = new Vue()
const SlaughterProgrammingStepsEventBus = new Vue()

export {
  SlaughterProgrammingEventBus,
  SlaughterProgrammingStepsEventBus
}